interface AboutProps {
  title: string
  description1: string
  description2: string
}

export default function About({
  title,
  description1,
  description2,
}: AboutProps) {
  return (
    <section id="about" className="py-24 bg-light">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-contrast mb-6">{title}</h2>
              <p className="text-content text-lg leading-relaxed mb-6">
                {description1}
              </p>
              <p className="text-content text-lg leading-relaxed">
                {description2}
              </p>
            </div>

            <div className="aspect-square bg-contour" />
          </div>
        </div>
      </div>
    </section>
  )
}
